<template>
	<div id="wrapper">
		<SidebarView :reports="true" />
		<div class="d-flex flex-column" id="content-wrapper">
			<div id="content">
				<TopbarView />
				<div class="container">
					<div class="card card-shape home-box">
						<div class="card-header">
							<div class="row align-items-center">
								<div class="col-6">
									<h6 class="m-0 fw-bold text-green">
										COA Heads Report
									</h6>
								</div>
								<div class="col-6 text-end">
									<b-button @click="generateExcel"
										class="btn-sm me-2 akkurate-green-btn akkurate-small">
										<font-awesome-icon :icon="['fas', 'file-excel']" />
									</b-button>
									<report-filter :form="form" @filterAction="getBalanceSheets" :filter="filter"
										:current_financial_year="financial_year
											">
									</report-filter>
									<b-button @click="printPDF" class="btn-sm me-2 akkurate-green-btn akkurate-small"
										title="Print">
										<font-awesome-icon :icon="['fas', 'print']" />
									</b-button>
									<b-button @click="downloadPDF" class="btn-sm akkurate-green-btn akkurate-small"
										title="Download">
										<font-awesome-icon :icon="['fas', 'download']" />
									</b-button>
								</div>
							</div>
							<div class="row">
								<div class="col-6"></div>
								<!-- <div class="col-6 text-end">
                  <b-button @click="printPDF" class="me-2 btn-sm akkurate-green-btn akkurate-small" title="Print"><font-awesome-icon :icon="['fas', 'print']"/></b-button>
                  <b-button @click="downloadPDF" class="btn-sm akkurate-green-btn akkurate-small" title="Download"><font-awesome-icon :icon="['fas', 'download']"/></b-button>
                </div> -->
							</div>
						</div>
						<div class="card-body" ref="pdfContent">
							<div class="row">
								<div class="col-12 col-md-12">
									<statement-institution :institution="institution" :current_date="false"
										:title="'COA HEADS SUMMARY'"></statement-institution>
								</div>
								<hr />
								<div class="row mb-2">
									<div class="col-12 small">
										Branch(es) : {{ branch_list_display }}
									</div>
								</div>
							</div>

							<div class="row">
								<div class="col-md-8"></div>
								<div class="col-md-4 text-end">
									<div>
										Terms:
										<span class="fw-bold">{{
											form.terms
										}}</span>
									</div>
									<span class="mt-2">From:
										<strong>{{ form.start_date }}</strong>
										To: <strong>{{ form.end_date }}</strong>
									</span>
								</div>
							</div>
							<!-- <div class="" style="text-align: center;">
                <div class="fw-bold akkurate-green">COA HEADS SUMMARY</div>
              </div> -->
							<div v-if="isBusy" class="text-center text-danger my-2">
								<b-spinner class="align-middle"></b-spinner>
								<strong>Loading...</strong>
							</div>
							<div v-else id="balance-sheet" class="row">
								<div class="col-12 my-2"></div>
								<div class="col-12 col-md-12 px-0 trans_details">
									<b-table-simple responsive outlined>
										<b-thead>
											<b-tr>
												<b-th class=""><span>GL Code</span></b-th>
												<b-th class=""><span>Head Name</span></b-th>
												<b-th class=""><span>Type</span></b-th>
												<!-- <b-th class="" ><span>Balance (GHS)</span></b-th> -->
												<b-th class=""><span>DR (GHS)</span></b-th>
												<b-th class=""><span>CR (GHS)</span></b-th>
											</b-tr>
										</b-thead>
										<b-tbody>
											<b-tr v-for="(value, item) in heads" :key="item" class="list-item">
												<b-td>{{ value.code }}</b-td>
												<b-td>{{
													value.display_name
												}}</b-td>
												<b-td>{{
													value.headtype?.name
												}}</b-td>
												<b-td>
													<span>
														{{
															displayNumber(
																value.adjusted_dr_amount
															)
														}}
													</span>
												</b-td>
												<b-td>
													<span>
														{{
															displayNumber(
																value.adjusted_cr_amount
															)
														}}
													</span>
												</b-td>
												<b-td> </b-td>
											</b-tr>
										</b-tbody>
										<tfoot>
											<tr>
												<th scope="col">TOTAL:</th>
												<th scope="col">
													SURPLUS: GHS
													{{
														displayNumber(
															difference
																? difference.toFixed(
																	2
																)
																: 0
														)
													}}
												</th>
												<th scope="col"></th>
												<th scope="col">
													{{
														displayNumber(
															total_debit
																? total_debit.toFixed(
																	2
																)
																: 0
														)
													}}
												</th>
												<th scope="col">
													{{
														displayNumber(
															total_credit
																? total_credit.toFixed(
																	2
																)
																: 0
														)
													}}
												</th>
											</tr>
										</tfoot>
									</b-table-simple>
								</div>
								<div class="col-md-12 trans_details">
									<div class="d-flex justify-content-between">
										<b-pagination class="mt-1" @change="navigatePage" v-model="currentPage"
											:total-rows="totalRecords" :per-page="perPage"
											aria-controls="member-table"></b-pagination>
										<div class="col text-end mt-1 akkurate-dark">
											<div>
												{{ currentPage }} -
												{{ perPage }} of
												{{ totalRecords }}
											</div>
											<b-form-group label="Per Page" label-size="sm" class="mb-0">
												<b-form-select @change="selectPerPage" id="per-page-select"
													v-model="perPage" :options="per_page_options"
													size="sm"></b-form-select>
											</b-form-group>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<footer></footer>
		</div>

		<!-- AI -->
		 <ChatBot />
		<!-- End AI -->
		<a class="d-inline scroll-to-top" href="#page-top">
			<i class="fas fa-angle-up"></i>
		</a>
	</div>
</template>
<script>
import SidebarView from "@/views/main/components/Sidebar.vue";
import TopbarView from "@/views/main/components/Topbar.vue";
import Footer from "@/views/main/components/Footer.vue";
import StatementInstitution from "@/views/main/components/institution/StatementInstitution.vue";
import ApiService from "@/core/services/api.service";
import Multiselect from "vue-multiselect";
import html2pdf from "html2pdf.js";
import ReportFilter from "@/views/main/pages/reports/form/ReportFilter.vue";
import ExcelJS from "exceljs";
import ChatBot from "@/views/components/AI/ChatBot.vue";
export default {
	components: {
		SidebarView,
		TopbarView,
		Footer,
		StatementInstitution,
		Multiselect,
		ReportFilter,
		ChatBot,
	},
	data() {
		return {
			financial_year: null,
			heads: [],
			profit_or_loss: 0,
			filter: {
				branch: "",
				start_date: "",
				end_date: "",
				year: "",
			},
			search: "Search",
			grant_total_expenses: 0,
			grant_total_incomes: 0,
			isBusy: false,
			isSearching: false,
			isLoadingInstitution: false,
			institution: "",
			start_date: "",
			end_date: "",
			items: [],
			total_debit: 0,
			total_credit: 0,
			difference: 0,
			branch_options: [],
			terms_options: ["YTD", "Periodic"],
			form: {
				start_date: this.getOneMonthEailer(),
				end_date: new Date().toISOString().split("T")[0],
				branches: [],
				products: [],
				branch_options: [],
				product_options: [],
				users: [],
				users_options: [],
				status: [],
				coa: [],
				coa_options: [],
				terms: "YTD",
				terms_options: ["YTD", "Periodic"],
				categories: [],
				loan_status:[],
			},
			filter: {
				branches: true,
				products: false,
				users: false,
				status: false,
				condition: false,
				coa: false,
				terms: true,
				start_date: true,
				end_date: true,
				loan_status:false,
			},
			per_page_options: ["10", "20", "50", "100", "500"],
			currentPage: 1,
			perPage: 10,
			totalRecords: 0,
		};
	},
	computed: {
		rows() {
			return this.items.length;
		},
		sumLoanBalance() {
			let total = 0;
			for (let i = 0; i < this.items.length; i++) {
				total = this.items[i].loan_balance;
			}
			return total;
		},
		total_amount() {
			let total = 0;
			for (let i = 0; i < this.heads.length; i++) {
				total +=
					this.heads[i].transactions.length > 0
						? this.heads[i].transactions[0].balance
						: 0;
			}
			return total;
		},
		sumSavingBalance() {
			let total = 0;
			for (let i = 0; i < this.items.length; i++) {
				total = this.items[i].saving_balance;
			}

			return total;
		},
		branch_list_display() {
			const selected = this.form.branches || [];
			const all = this.form.branch_options || [];

			if (selected.length > 0) {
				return selected.map(b => b.name).join(", ");
			}
			if (all.length > 0) {
				return all.map(b => b?.name).join(", ");
			}
			return "";
		}
	},

	created() {
		this.getInstitution();
		this.getBalanceSheets();
	},
	methods: {
		navigatePage(index) {
			this.isLoading = true;
			this.currentPage = index;
			this.getBalanceSheets();
		},
		selectPerPage(index) {
			this.perPage = index;
			this.getBalanceSheets();
		},
		async getBalanceSheets() {
			this.items = [];
			this.isBusy = true;
			this.search = "Processing...";
			this.isSearching = true;
			const branches = this.form.branches.map((index) => {
				return index.id;
			});
			await ApiService.post(
				"/reports/financials/coa/coaheads/summary",
				{
					page: this.currentPage,
					per_page: this.perPage,
					start_date: this.getBeginningOfYear(),
					end_date: new Date().toISOString().split("T")[0],
					branches: branches,
					terms: this.form.terms, //["YTD","Periodic"]
				}
			).then((response) => {
				this.isBusy = false;
				this.search = "Search";
				this.isSearching = false;
				var res = response.data;
				this.heads = res.heads.data;
				this.total_debit = res.total_debit;
				this.total_credit = res.total_credit;
				this.difference = res.difference;
				this.form.branch_options = response.data.branches;
				this.totalRecords = res.heads.total;
			})
				.catch((error) => {
					this.isBusy = false;
					this.search = "Search";
					this.isSearching = false;
					console.log(error);
				});
		},

		downloadPDF() {
			const content = this.$refs.pdfContent; // Reference to the HTML content you want to convert
			// console.log("here");
			const pdfOptions = {
				margin: [0.5, 0.2, 0.8, 0.2], //top, left, buttom, right
				filename: "statement.pdf",
				image: { type: "jpeg", quality: 0.98 },
				html2canvas: { scale: 2 },

				jsPDF: {
					unit: "in",
					format: "letter",
					orientation: "portrait",
				},
			};
			html2pdf()
				.from(content)
				.set(pdfOptions)
				.toPdf()
				.get("pdf")
				.then((pdf) => {
					var totalPages = pdf.internal.getNumberOfPages();
					var insit_name = this.institution.name;
					var insit_tele = this.institution.telephone;
					var insit_email = this.institution.email;
					var insit_motto = this.institution.motto;

					for (var i = 1; i <= totalPages; i++) {
						pdf.setPage(i);
						pdf.setFontSize(8);
						pdf.setTextColor(150);
						pdf.text(
							[
								"For Inquiries, Please Contact " +
								insit_name +
								", Customer Service on " +
								insit_tele +
								"",
								"or email us on " +
								insit_email +
								" " +
								insit_motto +
								"",
								"Page " + i + " of " + totalPages,
							],
							pdf.internal.pageSize.getWidth() / 2,
							pdf.internal.pageSize.getHeight() - 0.6,
							{ align: "center" }
						);
					}
				})
				.save();
		},
		async generateExcel() {
			const fileUrl = "/REPORT_TEMPLATE_NEW.xlsx"; // Path to the file in the public folder
			const imageUrl = "/default_logo.png"; // Path to your image file

			// Institution details
			const institutionName = this.institution.name;
			const institutionMotto = this.institution.motto;
			const institutionAddress = this.institution.address;
			const institutionPhone = this.institution.telephone;
			const institutionEmail = this.institution.email;
			const date =
				"FROM: " +
				this.form.start_date +
				" TO: " +
				this.form.end_date;
			const terms = "TERMS:  " + this.form.terms;

			try {
				// Fetch the Excel file from the public URL
				const response = await fetch(fileUrl);
				if (!response.ok) {
					throw new Error(
						`Network response was not ok: ${response.statusText}`
					);
				}
				const arrayBuffer = await response.arrayBuffer();

				// Load the file into ExcelJS
				const wb = new ExcelJS.Workbook();
				await wb.xlsx.load(arrayBuffer);

				// Access the first sheet
				const ws = wb.getWorksheet(1); // Get the first worksheet

				// Add Image to the top of the sheet
				const imageResponse = await fetch(imageUrl);
				const imageBuffer = await imageResponse.arrayBuffer();
				const imageId = wb.addImage({
					buffer: imageBuffer,
					extension: "png", // Adjust this if you're using a different image type (e.g., jpg)
				});

				// Insert the image at the top-left corner (row 1, column 1)
				ws.addImage(imageId, {
					tl: { col: 0, row: 0 }, // Top-left corner (adjust this as needed)
					ext: { width: 300, height: 200 }, // Set the image size (adjust width/height as needed)
				});

				// Insert institution details next to the image (starting at row 1, col 5)
				const institutionDetailsStartCol = 5; // Column where text starts after image
				const institutionDetailsRow = 1; // Row for institution details

				// Add the institution name, address, and phone number
				ws.getCell(`L${institutionDetailsRow}`).value =
					institutionName;
				ws.getCell(`L${institutionDetailsRow}`).font = {
					bold: true,
					size: 14,
				}; // Bold and bigger font for name

				ws.getCell(`L${institutionDetailsRow + 1}`).value =
					institutionAddress;
				ws.getCell(`L${institutionDetailsRow + 1}`).font = {
					size: 12,
				}; // Regular font size for address

				ws.getCell(`L${institutionDetailsRow + 2}`).value =
					institutionMotto;
				ws.getCell(`L${institutionDetailsRow + 2}`).font = {
					size: 12,
				}; // Regular font size for phone

				ws.getCell(`L${institutionDetailsRow + 3}`).value =
					institutionPhone;
				ws.getCell(`L${institutionDetailsRow + 3}`).font = {
					size: 12,
				}; // Regular font size for phone

				ws.getCell(`L${institutionDetailsRow + 4}`).value =
					institutionEmail;
				ws.getCell(`L${institutionDetailsRow + 4}`).font = {
					size: 12,
				}; // Regular font size for phone

				ws.getCell(`L${institutionDetailsRow + 6}`).value = date;
				ws.getCell(`L${institutionDetailsRow + 6}`).font = {
					size: 12,
				}; // Regular font size for phone

				ws.getCell(`L${institutionDetailsRow + 7}`).value = terms;
				ws.getCell(`L${institutionDetailsRow + 7}`).font = {
					size: 12,
				}; // Regular font size for phone

				// Optionally adjust the column width if the text is long
				ws.getColumn("K").width = 50; // Adjust the width of column D (if necessary)

				// Define header row
				const header = [
					"GL Code",
					"Head Name",
					"Type",
					"DR (GHS)",
					"CR (GHS)",
				];

				// Add header row starting from row 13 (or the next row after the image and details)
				const startingRow = institutionDetailsRow + 10; // Row 4 after institution details
				let headerRow = ws.getRow(startingRow);
				headerRow.values = header;
				headerRow.font = { bold: true };
				headerRow.commit(); // Commit the row to the worksheet

				// Add individual data rows
				let currentRow = startingRow + 1;

				// Process each item
				this.heads.forEach((item) => {
					const row = ws.getRow(currentRow);
					// Map item values to the corresponding header columns
					row.values = [
						item.code,
						item.display_name, // Remove extra spaces
						item.headtype?.name,
						item.adjusted_dr_amount,
						item.adjusted_cr_amount,
					];
					row.commit();
					currentRow++;
				});
				
				// Add totals row
				const totalsRow = ws.getRow(currentRow);
				totalsRow.values = [
					"TOTAL",
					"",
					"",
					this.total_debit?.toFixed(2) || "0.00",
					this.total_credit?.toFixed(2) || "0.00"
				];
				totalsRow.font = { bold: true };
				totalsRow.commit();
				currentRow++;

				// Add difference row
				const differenceLabel = this.difference < 0 ? "DEFICIT (GHS)" : "SURPLUS (GHS)";
				const differenceRow = ws.getRow(currentRow);
				differenceRow.values = [
					differenceLabel,
					"",
					"",
					"",
					Math.abs(this.difference)?.toFixed(2) || "0.00"
				];
				differenceRow.font = { bold: true };
				differenceRow.commit();

				// Write the file buffer and create a Blob for download
				const buffer = await wb.xlsx.writeBuffer();
				const blob = new Blob([buffer], {
					type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
				});

				// Create a download link and simulate a click to download the file
				const link = document.createElement("a");
				link.href = URL.createObjectURL(blob);
				link.download = `COA_Heads_Report_${this.form.start_date}_to_${this.form.end_date}.xlsx`;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			} catch (err) {
				console.error(
					"Error fetching, modifying, or downloading the Excel file:",
					err.message
				);
				// Fallback to simple export if template is not available
				this.generateExcelFallback();
			}
		},
		printPDF() {
			const content = this.$refs.pdfContent; // Reference to the HTML content you want to convert
			// console.log("here");
			const pdfOptions = {
				margin: [0.5, 0.2, 0.8, 0.2], //top, left, buttom, right
				filename: "statement.pdf",
				image: { type: "jpeg", quality: 0.98 },
				html2canvas: { scale: 2 },

				jsPDF: {
					unit: "in",
					format: "letter",
					orientation: "portrait",
				},
			};
			html2pdf()
				.from(content)
				.set(pdfOptions)
				.toPdf()
				.get("pdf")
				.then((pdf) => {
					var totalPages = pdf.internal.getNumberOfPages();
					var insit_name = this.institution.name;
					var insit_tele = this.institution.telephone;
					var insit_email = this.institution.email;
					var insit_motto = this.institution.motto;

					for (var i = 1; i <= totalPages; i++) {
						pdf.setPage(i);
						pdf.setFontSize(8);
						pdf.setTextColor(150);
						pdf.text(
							[
								"For Inquiries, Please Contact " +
								insit_name +
								", Customer Service on " +
								insit_tele +
								"",
								"or email us on " +
								insit_email +
								" " +
								insit_motto +
								"",
								"Page " + i + " of " + totalPages,
							],
							pdf.internal.pageSize.getWidth() / 2,
							pdf.internal.pageSize.getHeight() - 0.6,
							{ align: "center" }
						);
					}
					// Get the blob of the PDF
					return pdf.output("blob");
				})
				.then((pdfBlob) => {
					// Create a URL for the PDF blob
					var pdfUrl = URL.createObjectURL(pdfBlob);

					// Open the URL in a new tab
					const printWindow = window.open(
						pdfUrl,
						"_blank",
						"width=800,height=600"
					);
					printWindow.onload = () => {
						printWindow.print();
						URL.revokeObjectURL(pdfUrl);
					};
				})
				.catch((error) => {
					console.error("Error generating PDF:", error);
				});
		},
		// filterAction() {
		// 	this.changePerPageNumber(this.perPage);
		// },
		// changePerPageNumber(data) {
		// 	if (data == "All") {
		// 		this.perPage = this.items.length;
		// 		this.getCustomerProduct();
		// 	} else {
		// 		this.perPage = data;
		// 		this.getCustomerProduct();
		// 	}
		// },
		async getInstitution() {
			this.isLoadingInstitution = true;
			await ApiService.get("/settings/institution")
				.then((response) => {
					this.institution = response.data.data;
					this.financial_year = response.data.financial_year;
				})
				.catch((error) => {
					console.log(error);
				})
				.finally(() => {
					this.isLoadingInstitution = false;
				});
		},
	},
};
</script>
